export function checkIsImageOrPdf(filename: string) {
    return filename.match(/\.(?:png|jpeg|jpg|pdf|tif|tiff|heic|heif)$/i) !== null;
}
